import React from 'react';

interface UspItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const UspItem = ({ icon, title, description }: UspItemProps) => {
  return (
    <div className="usp__item">
      <div className="usp__icon-badge">{icon}</div>
      <div className="usp__text-wrapper">
        <p className="usp__item-title">{title}</p>
        <p className="usp__item-description">{description}</p>
      </div>
    </div>
  );
};

export default UspItem;
